<template>
  <intersect @enter="animate = true">
    <div class="left fadeUp" v-if="itemData" :class="animate ? 'animate' : ''">
      <div
        class="polTtl noto-semibold"
        v-if="_.get(itemData, 'conf.useHeader') == 1"
      >
        {{ _.get(itemData, "conf.header.title") }}
      </div>
      <div class="polDescr" v-if="_.get(itemData, 'conf.useHeader') == 1">
        {{ _.get(itemData, "conf.header.teaser") }}
      </div>
      <div class="policyListOuter">
        <div class="policyListInnerOver">
          <div class="policyListInner scroll">
            <a
              :href="_.get(list, 'files.0.url')"
              target="_blank"
              class="policyList"
              v-for="(list, index) in itemData.data"
              :key="index"
            >
              <div class="ttl noto-semibold">{{ list.title }}</div>
              <div class="but">
                <span class="noto-semibold">{{ $fn.tr("download") }}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                >
                  <path
                    id="Subtraction_85"
                    data-name="Subtraction 85"
                    d="M12.5,25c-4.883,0-7.9-.836-9.773-2.711S0,17.392,0,12.5C0,7.7.857,4.705,2.781,2.781S7.7,0,12.5,0c4.893,0,7.912.839,9.791,2.722S25,7.614,25,12.5s-.836,7.916-2.711,9.792S17.395,25,12.5,25ZM8.219,17.5h0v2.306h8.553V17.5ZM7.689,9.351a.679.679,0,0,0-.65.424.618.618,0,0,0,.16.686l4.832,4.57a.694.694,0,0,0,.482.188A.717.717,0,0,0,13,15.03l4.826-4.57a.618.618,0,0,0,.16-.686.679.679,0,0,0-.65-.424H14.586V5.646A.67.67,0,0,0,13.9,5h-2.76a.67.67,0,0,0-.687.648V9.351Z"
                    fill="#bcbec0"
                  />
                </svg>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </intersect>
</template>

<script>
import Intersect from "vue-intersect";

export default {
  props: {
    itemData: Object,
    required: true,
  },
  components: { Intersect },
  data() {
    return {
      animate: false,
    };
  },
};
</script>